import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import DynamicDataGrid from './DynamicDataGrid/DynamicDataGrid';
import GenericButton from './GenericButton';
import GenericSearch from './GenericSearch';
import StudySelectorRadioButtons from './StudySelectorRadioButtons';
import StudySelectorDropDown from './StudySelectorDropDown';
import { copyContent } from '../../util/CommonUtils';
import * as studyActions from '../../actions/studyActions';
import * as crosstabActions from '../../actions/crosstabActions';
import * as dictionaryActions from '../../actions/dictionaryActions';
import * as quickReportsActions from '../../actions/quickReportsActions';

import { DATAHAUL_CONSTANT, VISAHAUL_CONSTANT, CROSSTAB_CONSTANT,
  QUICKREPORTS_CONSTANT, QTS_CONSTANT, FLEX_STUDY_TAG } from '../../constants';

const columns = [
  { key: 'studyDescription', name: 'Name', sortable: true, width: 370 },
  { key: 'studyYear', name: 'Year', sortable: true, width: 70 },
  { key: 'studyRelease', name: 'Season', sortable: true, width: 80 },
  {
    key: 'fieldStartDate',
    name: 'Start Field Date',
    sortKey: 'fieldStart',
    sortable: true,
    width: 120,
  },
  {
    key: 'fieldEndDate',
    name: 'End Field Date',
    sortKey: 'fieldEnd',
    sortable: true,
    width: 120,
  },
];

const columnsWhileInQtsView = [
  { key: 'studyDescription', name: 'Study Name', sortable: true, width: 420 },
  { key: 'studyYear', name: 'Year', sortable: true },
  { key: 'studyRelease', name: 'Season', sortable: true },
  {
    key: 'fieldStartDate',
    name: 'Start Field Date',
    sortKey: 'fieldStart',
    sortable: true,
  },
  {
    key: 'fieldEndDate',
    name: 'End Field Date',
    sortKey: 'fieldEnd',
    sortable: true,
  },
];

const copyDataGridData = rows => {
  const str = rows.reduce(
    (acc, currentVal) =>
      `${acc}\n${currentVal.sd}\t${currentVal.sy}\t${
        currentVal.sr
      }\t${new Date(currentVal.fs)} \t${new Date(currentVal.fe)}`,
    'Name\tYear\tSeason\tStart Field Date\tEnd Field Date',
  );
  copyContent(str);
};

class StudySelector extends Component {
  constructor(props) {
    super(props);
    let selectedRow = {};
    if (
      this.props.qtsStudies !== undefined &&
      this.props.selectedModule === QTS_CONSTANT
    ) {
      this.rows = this.props.qtsStudies.data.map(study => {
        const row = {
          ...study,
          id: study.pn,
          study: study.st,
          studyDescription: study.sd,
          studyYear: study.sy,
          studyRelease: study.sr,
          fieldStartDate: new Date(study.fs).toLocaleDateString(),
          fieldEndDate: new Date(study.fe).toLocaleDateString(),
          fieldStart: study.fs,
          fieldEnd: study.fe,
          divisor: study.dv,
          weightType: study.wt,
          warningType: study.wnt,
          customWeights: study.cw,
          isSelected:
            props.selectedStudy && props.selectedStudy.id === study.pn,
        };

        if (row.isSelected) {
          selectedRow = { ...row };
        }
        return row;
      });
    } else if (
      this.props.selectedModule === QUICKREPORTS_CONSTANT ||
      this.props.selectedModule === DATAHAUL_CONSTANT
    ) {
      this.rows = this.props.studies.data
        .filter(studyData => !studyData.st.toLowerCase().includes(FLEX_STUDY_TAG))
        .map(study => {
          const row = {
            id: study.pn,
            study: study.st,
            studyDescription: study.sd,
            studyYear: study.sy,
            studyRelease: study.sr,
            fieldStartDate: new Date(study.fs).toLocaleDateString(),
            fieldEndDate: new Date(study.fe).toLocaleDateString(),
            fieldStart: study.fs,
            fieldEnd: study.fe,
            divisor: study.dv,
            weightType: study.wt,
            warningType: study.wnt,
            customWeights: study.cw,
            isSelected:
              props.selectedStudy &&
              props.selectedStudy.pn === study.pn,
            propCodes: study.propCodes,
          };

          if (row.isSelected) {
            selectedRow = { ...row };
          }
          return row;
        });
    } else {
      this.rows = this.props.studies.data.map(study => {
        const row = {
          id: study.pn,
          study: study.st,
          studyDescription: study.sd,
          studyYear: study.sy,
          studyRelease: study.sr,
          fieldStartDate: new Date(study.fs).toLocaleDateString(),
          fieldEndDate: new Date(study.fe).toLocaleDateString(),
          fieldStart: study.fs,
          fieldEnd: study.fe,
          divisor: study.dv,
          weightType: study.wt,
          warningType: study.wnt,
          customWeights: study.cw,
          isSelected:
            props.selectedStudy &&
            props.selectedStudy.pn === study.pn,
          propCodes: study.propCodes,
        };

        if (row.isSelected) {
          selectedRow = { ...row };
        }
        return row;
      });
    }

    this.state = {
      // searchText: '',
      gridDataRows: [...this.rows],
      selectedRow,
      selectedWeightType: props.selectedStudy
        ? props.selectedStudy.wt
        : 1,
    };
    this.studyGrid = React.createRef();
  }

  componentDidMount() {
    if (this.props.studySelectionChange !== undefined) {
      const getSelectedStudy = _.find(this.state.gridDataRows, {
        isSelected: true,
      });
      this.props.studySelectionChange(getSelectedStudy);
    }
  }

  handlefilteredList = result => this.setState({ gridDataRows: result });

  handleOK = () => {
    const {
      id,
      study,
      studyDescription,
      studyYear,
      studyRelease,
      fieldStart,
      fieldEnd,
      divisor,
      warningType,
      weightType,
      customWeights,
      // propCodes,
    } = this.state.selectedRow;

    const selectedStudy = {
      pn: id,
      wt: weightType === 3 ? 1 : this.state.selectedWeightType,
      st: study,
      sd: studyDescription,
      sy: studyYear,
      sr: studyRelease,
      fs: fieldStart,
      fe: fieldEnd,
      dv: divisor,
      wnt: warningType,
      cw: customWeights,
    };

    this.props.crosstabActions.addDDNHCSData([]);
    this.props.crosstabActions.clearSampleWeightedKPIs();
    this.props.quickReportsActions.clearSampleWeightedKPIs();

    let selectedModule = this.props.selectedModule ? this.props.selectedModule : CROSSTAB_CONSTANT;
    if (this.props.selectedModule && (this.props.selectedModule.includes(VISAHAUL_CONSTANT) ||
      this.props.selectedModule.includes(DATAHAUL_CONSTANT))) {
      selectedModule = this.props.selectedModule.toLowerCase();
    }
    this.props.studyActions.updateModuleStudy(
      selectedModule,
      selectedStudy,
    );
    this.props.handleParentHide(selectedStudy);
    this.props.dictionaryActions.clearTreeLoadNodeList();
    const fetchStandardBasetParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccount,
      productNo: selectedStudy.pn,
    };
    if (!this.props.loginResponse.data.universityUser) {
      this.props.crosstabActions.fetchStandardBaseList(fetchStandardBasetParams);
    }
  };

  handleRowsSelectionChange = () => {
    const selectedRow = this.studyGrid.current.decoratedRef.current
      .getSelectedEntries()[0];
    if (this.props.studySelectionChange !== undefined) {
      this.props.studySelectionChange(selectedRow);
    }
    this.setState({ selectedRow });
  };

  handleWeightTypeChange = selectedWeightType =>
    this.setState({ selectedWeightType });

  renderWeightTypeSelector = () => {
    if (this.state.selectedRow) {
      if (this.state.selectedRow.customWeights) {
        return (
          <StudySelectorDropDown
            customWeightsOption={this.state.selectedRow.customWeights}
            handleWeightTypeChange={this.handleWeightTypeChange}
            defaultSelectedOption={this.state.selectedWeightType}
          />
        );
      }
      if (this.state.selectedRow.wt === 3) {
        return <div />;
      }
    }
    return (
      <StudySelectorRadioButtons
        handleWeightTypeChange={this.handleWeightTypeChange}
        defaultSelectedOption={this.state.selectedWeightType}
      />
    );
  };

  render() {
    return (
      <div className="row expanded">
        <div className="small-12 large-12 margin-bottom-15">
          <div className="row expanded">
            <div className="large-12 columns search-box padding-search-box">
              {this.props.selectedModule === QTS_CONSTANT ? (
                <span className="qts-study-select-header">
                  Select Your Study
                </span>
              ) : (
                ''
              )}
              <span className="large-4 float-left display-block position-relative">
                <GenericSearch
                  searchItems={this.rows}
                  searchField="sd"
                  handleSearchResult={this.handlefilteredList}
                />
                <i className="search-icon2" />
              </span>
              <div className="large-5 columns">
                <h4
                  title={
                    this.state.selectedRow
                      ? this.state.selectedRow.studyDescription
                      : ''
                  }
                  className="txt_h4"
                >
                  {this.state.selectedRow
                    ? this.state.selectedRow.studyDescription
                    : ''}
                </h4>
              </div>
              <div className="large-1 columns">
                {this.props.selectedModule !== QTS_CONSTANT ? (
                  <GenericButton
                    name=""
                    btnStyle="copy-icon"
                    title="Copy"
                    onBtnClick={() => copyDataGridData(this.state.gridDataRows)}
                  />
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className={this.props.selectedModule === QTS_CONSTANT && 'padding-top-10'}
        >
          {this.props.selectedModule === QTS_CONSTANT ? (
            <div className="mandate-select-study">
              Your Turn-Key Omnibus is proprietary, powerful and actionable.
              It is appended to a MRI-Simmons National Study of your choosing.
              <br /> The most recent study available is selected to append your Turn-Key Omnibus to.
              Feel free to change to another study.
            </div>
          ) : (
            ''
          )}
          <DynamicDataGrid
            ref={this.studyGrid}
            className="study-selector-data-grid"
            gridHeight={this.props.selectedModule === QTS_CONSTANT ? 395 : 375}
            rows={this.state.gridDataRows}
            columns={
              this.props.selectedModule !== QTS_CONSTANT
                ? columns
                : columnsWhileInQtsView
            }
            rowSelectionType="Single"
            isRowsDraggable={false}
            handleRowsSelectionChange={this.handleRowsSelectionChange}
            rowHeight={this.props.selectedModule === QTS_CONSTANT ? 40 : 35}
            handleRowDoubleClick={() => {
              this.handleOK();
            }}
          />
        </div>
        <div className="modal-footer small-12 large-12 columns padding-bottom-0 padding-left-0 padding-right-0">
          <div className="row expanded">
            {this.props.selectedModule !== QTS_CONSTANT ? (
              <div className="large-6 columns">
                {this.renderWeightTypeSelector()}
              </div>
            ) : (
              ''
            )}
            <div className="large-12 qts-button-section">
              {this.props.selectedModule !== QTS_CONSTANT ? (
                <GenericButton
                  name="Select"
                  btnStyle="button red button-with-icon select-btn"
                  onBtnClick={() => {
                    this.handleOK();
                  }}
                />
              ) : (
                <div>
                  <div className="qts-red-text most-recent-section">
                    *Most recent study available.
                  </div>
                  <div className="large-6 display-inline">
                    <GenericButton
                      name="Back"
                      btnStyle="button qts-back-btn"
                      onBtnClick={() => {
                        this.props.backToProjects();
                      }}
                    />
                  </div>
                  <div className="large-6 display-inline text-align-right">
                    <GenericButton
                      name="Continue"
                      btnStyle="button qts-save-continue-btn"
                      btnDisabled={
                        this.state.selectedRow === undefined ||
                        this.state.selectedRow.studyDescription === undefined ||
                        this.state.selectedRow.id === undefined
                      }
                      onBtnClick={() => {
                        this.props.saveAndContinue();
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

StudySelector.propTypes = {
  handleParentHide: PropTypes.func,
  selectedModule: PropTypes.string,
  activeAccount: PropTypes.number,
  selectedStudy: PropTypes.shape({
    pn: PropTypes.number,
    wt: PropTypes.number,
    id: PropTypes.number,
  }),
  studies: PropTypes.instanceOf(Object),
  studyActions: PropTypes.shape({
    updateModuleStudy: PropTypes.func,
  }),
  crosstabActions: PropTypes.shape({
    addDDNHCSData: PropTypes.func,
    clearSampleWeightedKPIs: PropTypes.func,
    fetchStandardBaseList: PropTypes.func,
  }),
  quickReportsActions: PropTypes.shape({
    clearSampleWeightedKPIs: PropTypes.func,
  }),
  dictionaryActions: PropTypes.shape({
    clearTreeLoadNodeList: PropTypes.func,
  }),
  qtsStudies: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object),
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
      universityUser: PropTypes.bool,
    }),
  }),
  backToProjects: PropTypes.func,
  saveAndContinue: PropTypes.func,
  studySelectionChange: PropTypes.func,

};

function mapStateToProps(state) {
  return {
    studies: state.study.studies,
    loginResponse: state.login.loginResponse,
    activeAccount: state.account.activeAccountId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    studyActions: bindActionCreators(studyActions, dispatch),
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(StudySelector);
